<div class="myself">
    <div>
        <p i18n="@@account.contract-flow.add-sign.introduction">
            The contract must be signed by the legal representatives of {{ companyName }} with chamber of commerce
            number {{ chamberOfCommerceNumber }}.
        </p>
    </div>

    <h4 i18n="@@account.contract-flow.add-sign.question-one.title">Are you authorized to sign for {{ companyName }}</h4>

    <mat-radio-group [formControl]="userIsSigningPersonControl">
        <mat-radio-button [value]="true" i18n="@@account.contract-flow.add-sign.question-one.yes">Yes</mat-radio-button>
        <mat-radio-button [value]="false" i18n="@@account.contract-flow.add-sign.question-one.no">No</mat-radio-button>
    </mat-radio-group>

    <p
        *ngIf="userIsSigningPersonControl.value === true"
        i18n="@@account.contract-flow.add-sign.question-one.yes-comment"
    >
        You can sign after providing all the signing persons. This can be done fully online through a bank transfer of 1
        cent
    </p>
</div>

<hr />

<ng-container *ngIf="userIsSigningPersonControl.value === false || userIsSigningPersonControl.value === true">
    <ng-container *ngIf="userIsSigningPersonControl.value === true">
        <h4 i18n="@@account.contract-flow.add-sign.question-two.title.user-as-signing-person">
            Do somebody else also need to sign?
        </h4>
        <p i18n="@@account.contract-flow.add-sign.question-two.text.user-as-signing-person">
            If so, please add an e-mail address for each signing person below. We'll send the signing persons an e-mail
            with instructions about how to sign the contract.
        </p>
    </ng-container>

    <ng-container *ngIf="userIsSigningPersonControl.value === false">
        <h4 i18n="@@account.contract-flow.add-sign.question-two.title">E-mail addresses signing persons</h4>
        <p i18n="@@account.contract-flow.add-sign.question-two.text">
            Please add an e-mail address for each signing person below. We'll send the signing persons an e-mail with
            instructions about how to sign the contract.
        </p>
    </ng-container>

    <div *ngFor="let extraSigningPerson of extraSigningPersons; let index = index" class="extraSigningPerson">
        <mg-email-input
            [formControl]="extraSigningPerson.control"
            class="extraSigningPerson__emailAdress"
            placeholder="E-mail address signing person"
            i18n-placeholder="@@account.contract-flow.add-sign.question-two.placeholder-email"
        ></mg-email-input>
        <a
            mat-icon-button
            (click)="removeExtraSigningPerson(index)"
            class="extraSigningPerson__remove"
            [class._is_disabled]="extraSigningPersons.length === 1 && userIsSigningPersonControl.value === false"
        >
            <mat-icon>delete</mat-icon>
        </a>
    </div>

    <mat-error *ngIf="containsDuplicateEmails" class="duplicate-error">
        <mat-icon>error</mat-icon>
        <ng-container i18n="@@account.contract-flow.add-sign.question-two.duplicate-email-error"
            >Multiple signing persons have the e-mail address {{ duplicateEmail }}.</ng-container
        >
    </mat-error>

    <a mat-icon-button (click)="$event.preventDefault(); addExtraSigningPerson()">
        <mat-icon>add</mat-icon>
        <ng-container i18n="@@account.contract-flow.add-sign.question-two.add-button"
            >Add an e-mail address for a signing person</ng-container
        >
    </a>
</ng-container>
